import { useForm } from 'react-hook-form';
import './form.scss';
import { MinFormItem } from './form-props'

function Form<T extends MinFormItem>({
    id,
    formName,
    formInputs,
    onSubmit,
    children
}
:
{
    id: string,
    formName: string,
    formInputs: T[],
    onSubmit: (data:any) => void,
    children?: any
}) {
    const { register, handleSubmit, formState: { errors } } = useForm();

    if (errors.length > 0)
        console.log(errors);

    function renderInput(item: T, idx: number) {
        if (item.Rows) {
            return (<textarea key={idx} placeholder={item.Placeholder} defaultValue={item.Value} {...register(item.Name as `${string}`, {required: item.Required})} rows={item.Rows} />)
        }
        return (
            <input key={idx} type={item.Type} placeholder={item.Placeholder} defaultValue={item.Value} {...register(item.Name as `${string}`, {required: item.Required})}  />
        )
    }

    return (
        <div id={id} className="form-container">
            {formName.length > 0 && <h2>{formName}</h2>}
            <form onSubmit={handleSubmit(onSubmit)}>
                {formInputs.map((item, idx) => renderInput(item, idx))}

                <button type="submit"> SUBMIT </button>
            </form>
            {children}
        </div>
    )
}

export default Form;